/* eslint-disable no-unused-vars */
import { Button, Grid } from "@mui/material";
import { green, red } from "@mui/material/colors";
import PDialog from "../../components/pos/PDialog";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { withStyles } from "@mui/styles";

const OptionButton = withStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100%",
    fontSize: "1.28rem",

    /*color: theme.palette.getContrastText(purple[500]),
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },*/
  },
}))(Button);

export const DuplicateInvoicePrompt = (props) => {
  const { t } = useTranslation();
  const translate = t;
  props.biRef.DuplicateInvoicePrompt = {
    parentEvent: parentEvent,
  };

  const [openWindow, setOpenWindow] = useState(true);

  function onCloseWindow() {
    props.setOpenWindow(false);
  }

  useEffect(() => {}, []);

  function parentEvent(event, value) {
    if ("openWindow" === event) {
      setOpenWindow(value);
    }
  }

  function onSave() {}

  function valdate() {
    return true;
  }

  function onNoClicked() {
    onCloseWindow();
  }
  function onYesClicked() {
    props.onDuplicateInvoice();
    onCloseWindow();
  }

  function onDelete() {}
  const content = (
    <Grid container style={{ width: "70vw" }}>
      <Grid item xs={6}>
        <div
          style={{
            marginLeft: 2,
            marginRight: 2,
            height: "100%",
          }}
        >
          <OptionButton
            style={{
              backgroundColor: red[500],
              color: "#fff",
            }}
            onClick={() => {
              onNoClicked();
            }}
          >
            {translate("No")}
          </OptionButton>
        </div>
      </Grid>
      <Grid item xs={6}>
        <div
          style={{
            marginLeft: 2,
            marginRight: 2,
            height: "100%",
          }}
        >
          <OptionButton
            style={{
              backgroundColor: green[500],
              color: "#fff",
            }}
            onClick={() => {
              onYesClicked();
            }}
          >
            {translate("Yes")}
          </OptionButton>
        </div>
      </Grid>
    </Grid>
  );
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={translate("Duplicate Invoice ?")}
          maxWidth={"md"}
          fullWidth={false}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          saveLabel={translate("Proceed")}
          mode={"view"}
          hideSave={true}
        ></PDialog>
      )}
    </div>
  );
};
export default DuplicateInvoicePrompt;
